export enum VisualSignatureRequirement {
  OPTIONAL = 'optional',
  REQUIRED = 'required',
  PROHIBITED = 'prohibited'
}
